<header class="header" [class.sticky]="isSticky()">
  <section class="topbar">
    <div class="container">
      <div class="topbar__flex">
        <a [routerLink]="['/news']" class="logo"></a>
        <div class="navigation__items">
          <a
            href="{{ dashboardUrl }}"
            class="navigation__link"
            routerLinkActive="navigation__link--active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="navigation__link-inner">{{ "Navigation.Dashboard" | translate }}</span>
          </a>
          <a class="navigation__link">&nbsp;|&nbsp;</a>
          <a href="{{ newsUrl }}" class="navigation__link navigation__link--active">
            <span class="navigation__link-inner">{{ "Navigation.News" | translate }}</span>
          </a>
        </div>
        <div class="topbar__items">
          <div class="topbar__item__wrapper">
            @for (lang of translate.getLangs(); track lang) {
              <span class="topbar__language">
                <span
                  (click)="switchLanguage(lang)"
                  [routerLink]="['/news', lang]"
                  [class.topbar__language--active]="translate.currentLang() === lang"
                >
                  {{ lang }}
                </span>
              </span>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="navigation" [class.fixed]="false">
    <div class="container">
      <div class="navigation__flex">
        <div class="navigation__text--wrapper">
          <service-icon size="l" type="news" />
          <span class="navigation__text">
            @if (isChildRoute()) {
              <button (click)="goBack()" class="navigation__text--top navigation__back">
                <svg-icon src="assets/images/icons/icon-arrow-left.svg" class="back-button"> </svg-icon>
                {{ "Global.Action.Back" | translate }}
              </button>
            } @else {
              <span class="navigation__text--top">
                {{ "Navigation.News" | translate }}
              </span>
            }
            <span class="navigation__text--main" [innerHTML]="forceTitle() ? forceTitle() : mainNavText()"></span>
          </span>
        </div>
      </div>
    </div>
  </div>
</header>
